<template>
  <div v-loading="loading">
    <div class="rj-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ name: 'ChiefContractList' }">
          待付款合同
        </el-breadcrumb-item>
        <el-breadcrumb-item>办理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="rj-page-card">
      <div class="rj-page-card__title">
        合同基本信息
      </div>
      <div class="rj-page-card__content">
        <div class="rj-row">
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                合同编号：
              </div>
              <div class="rj-baseinfo__item">
                {{ info.contractNum }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                项目名称：
              </div>
              <div class="rj-baseinfo__item">
                {{ info.projectName }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                最终客户：
              </div>
              <div class="rj-baseinfo__item">
                {{ info.finalCustomer }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                合同日期：
              </div>
              <div class="rj-baseinfo__item">
                {{ info.createTime }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                订单金额：
              </div>
              <div class="rj-baseinfo__item">
                <span class="money">{{ Number(info.orderSales).toFixed(2) }} 元</span>
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                实际结算金额：
              </div>
              <div class="rj-baseinfo__item">
                <span class="money">{{ info.actualSettlementAmount }} 元</span>
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                预付款比例：
              </div>
              <div class="rj-baseinfo__item">
                <span class="money">{{ info.prepaymentRatioStr }}</span>
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                冲销金额：
              </div>
              <div class="rj-baseinfo__item">
                <span class="money">{{ info.borrowPrice }}元</span>
              </div>
            </div>
          </div>
          <div class="rj-col-2">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                首付款金额：
              </div>
              <div class="rj-baseinfo__item">
                <span class="money">{{
                  (info.prepaymentAmountStr + info.borrowPrice).toFixed(2)
                }}
                  元</span>
                <span class="amountSty">公式：（实际结算金额-冲销金额）*预付款比例+冲销金额</span>
              </div>
            </div>
          </div>

          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                已分配金额：
              </div>
              <div class="rj-baseinfo__item">
                <span class="money">{{ info.assignAll }} 元</span>
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                未分配金额：
              </div>
              <div class="rj-baseinfo__item">
                <span class="money">{{ unallocatedAmount() }}元</span>
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                已分配比例：
              </div>
              <div class="rj-baseinfo__item">
                <span class="money">{{ info.proportion }} %</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div v-if="deliveryNumList.length !== 0">
        此合同下有未分配完成的分批发货申请单，请点击分批申请单号进行分配：
      </div>
      <div v-for="(item, index) in deliveryNumList" :key="index">
        <div style="padding: 10px 0; width: 20%; float: left; height: 30px">
          <span
            class="money"
            style="margin-right: 20px; cursor: pointer"
            @click="toPath(item)"
          >{{ item.deliveryNum }}</span>
        </div>
      </div>
    </div>
    <div
      v-if="deliveryNumList.length === 0"
      class="rj-page-card"
      style="clear: both"
    >
      <div class="rj-page-card__title">
        款项分配
      </div>
      <div class="rj-page-card__content">
        <p v-if="CustomizationList.length" style="padding: 10px 0; color: red">
          此单涉及定制化产品，具体型号为：
          <el-tag v-for="(item, index) in CustomizationList" :key="index">
            {{ item.productName }}
          </el-tag>
          下单时请代理商支付此合同全部货款的30%进行下单，有疑问，请联系对应销售。
        </p>

        <el-form :inline="true">
          <el-form-item label="电汇单编号:">
            <el-input v-model="searchForm.telegraphicTransferNum" clearable placeholder="电汇单编号" />
          </el-form-item>
          <el-form-item label="汇款金额:">
            <el-input-number
              v-model="searchForm.minRemittanceAmount"
              :controls="false"
              :precision="2"
              :min="0"
              placeholder="最小金额"
              class="input-width"
            />
            <span>-</span>
            <el-input-number
              v-model="searchForm.maxRemittanceAmount"
              :controls="false"
              :precision="2"
              :min="0"
              placeholder="最大金额"
              class="input-width"
            />
          </el-form-item>
          <el-form-item label="汇款日期:">
            <el-date-picker
              v-model="searchForm.rangeDate"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="-"
              clearable
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              class="tange-date-width"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" :loading="isSearchLoading" @click="doSearch">
              查询
            </el-button>
          </el-form-item>
        </el-form>

        <el-table
          v-loadmore="handleScroll"
          v-loading="isSearchLoading"
          :data="tableData"
          border
          style="width: 100%"
          height="500"
        >
          <el-table-column
            prop="telegraphicTransferNum"
            label="电汇底单编号"
            align="left"
            fixed="left"
          />
          <el-table-column
            prop="remittanceAmount"
            label="汇款金额"
            align="right"
            header-align="left"
          />
          <el-table-column
            prop="remittanceDate"
            label="汇款日期"
            align="left"
          />
          <el-table-column
            prop="importAccount"
            label="汇入账户"
            align="left"
          />
          <el-table-column
            prop="importCompany"
            label="汇入公司"
            align="left"
          />
          <el-table-column
            prop="arrivalMoneyDate"
            label="到款日期"
            align="left"
          />
          <el-table-column
            prop="summary"
            label="摘要"
            align="left"
            width="180"
          />
          <el-table-column
            prop="usedAmount"
            label="已使用金额"
            align="right"
            header-align="left"
          />
          <el-table-column
            prop="unusedAmount"
            label="可用余额"
            align="right"
            header-align="left"
          />
          <el-table-column
            prop="assignAmount"
            label="本次分配金额"
            align="right"
            header-align="left"
            fixed="right"
            width="150"
          >
            <template v-slot="{ row }">
              <el-input-number
                v-model="row.assignAmount"
                style="width: 100%"
                :precision="2"
                :min="0"
                label="描述文字"
                @blur="assignBlur(row)"
              />
            </template>
          </el-table-column>

          <div slot="append" class="append-wrap">
            <span v-if="isShowAppend">
              <i class="el-icon-loading icon" />
              <span>加载中...</span>
            </span>
            <span v-else-if="!isShowAppend && tableData.length">
              加载完成
            </span>
          </div>
        </el-table>

        <div style="margin-top: 20px">
          <el-button type="primary" @click="submit">
            确认分配
          </el-button>
          <div
            style="
              color: #606266;
              height: 41px;
              line-height: 41px;
              display: inline-block;
              margin-left: 20px;
            "
          >
            <div>
              本次分配总和：<span class="money">{{ assignAllTotal }} 元</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="确认分配"
      :visible.sync="dialogVisible"
      width="700px"
      top="15px"
    >
      <span v-if="sureNum > 0" style="color: red">注：已分配金额总计{{
        (info.assignAll + allAmount() * 1).toFixed(2)
      }}和首付款{{
        (info.prepaymentAmountStr + info.borrowPrice).toFixed(2)
      }}差{{ sureNum.toFixed(2) }}元，请分配足额首付款，否则会影响下单。</span>
      <el-table
        :data="tableDialog"
        border
        style="width: 100%"
        :summary-method="getSummaries"
        show-summary
      >
        <el-table-column type="index" width="60" label="序号" align="left" fixed="left" />
        <el-table-column prop="contractNum" label="合同号" align="left" />
        <el-table-column
          prop="telegraphicTransferNum"
          label="电汇底单编号"
          align="left"
        />
        <el-table-column
          prop="actualSettlementAmount"
          label="实际结算金额"
          align="right"
          header-align="left"
        />
        <el-table-column
          prop="assignAmount"
          label="本次分配金额"
          align="right"
          header-align="left"
        />
      </el-table>

      <div class="footer-btn">
        <el-button type="default" @click="cancel">
          取消
        </el-button>
        <el-button type="primary" :loading="loading" @click="submitAxios">
          确认分配
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import axios, {
  getContractDetailAllInfoByConNum,
  dealtContractToAssignInfoListTransfer,
  getNotAssignedPartialByContractNum,
  selectAssignInfoByContractNum
} from '@/API';

import { Subtr, numAdd, debounce } from '@/libs/util';

export default {
  directives: {
    loadmore (el, binding) {
      const selectWrap = el.querySelector('.el-table__body-wrapper');
      selectWrap.addEventListener('scroll', function () {
        if (this.scrollHeight - Math.ceil(this.scrollTop) <= this.clientHeight) {
          binding.value();
        }
      });
    }
  },

  props: {
    contractNum: {
      type: [String, Number],
      required: true
    }
  },

  data () {
    return {
      loading: false,
      tableData: [],
      info: {},
      dialogVisible: false,
      deliveryNumList: [],
      tableDialog: [],
      isSureText: true,
      sureNum: 0,

      searchForm: {},
      isSearchLoading: false,

      // 下拉加载完毕
      isLoadCompleted: false,

      pageData: {
        pageIndex: 1,
        pageSize: 50,
        total: 0
      }
    };
  },

  computed: {
    // 定制化产品
    CustomizationList () {
      if (!this.info.contractProductInfos) {
        return [];
      }
      return this.info.contractProductInfos.filter((item) => {
        return item.customizationOrNot;
      });
    },
    unassignAll () {
      if (this.info.contractSum) {
        return numAdd(this.info.contractSum, this.info.assignAll ? this.info.assignAll * -1 : 0);
      }
      return 0;
    },
    assignAllTotal () {
      let total = 0;
      this.tableData.forEach((item) => {
        total = numAdd(item.assignAmount || 0, total);
      });
      return total;
    },

    // 是否显示触底 loading
    isShowAppend () {
      if (this.isLoadCompleted) {
        return false;
      } else {
        return this.pageData.total > this.tableData.length;
      }
    }
  },

  mounted () {
    this.initData();
  },

  methods: {
    // 格式化回款日期
    formatRangeDate (array) {
      if (array && array[0] && array[1]) {
        return { beginRemittanceDate: array[0], endRemittanceDate: array[1] };
      } else {
        return {};
      }
    },

    // 搜索的按钮
    async doSearch () {
      this.pageData.pageIndex = 1;

      let params = {
        contractNum: this.contractNum,
        pageIndex: this.pageData.pageIndex,
        pageSize: this.pageData.pageSize,
        telegraphicTransferNum: this.searchForm.telegraphicTransferNum,
        minRemittanceAmount: this.searchForm.minRemittanceAmount,
        maxRemittanceAmount: this.searchForm.maxRemittanceAmount,
        ...this.formatRangeDate(this.searchForm.rangeDate)
      };

      this.isSearchLoading = true;
      selectAssignInfoByContractNum(params)
        .then(res => {
          this.isSearchLoading = false;
          let { status, data } = res.data;
          if (status === '200') {
            if (data.list.length) {
              data.list.forEach((item) => (item.assignAmount = 0));
              this.tableData = data.list;
              this.pageData.total = data.total;
            } else {
              this.tableData = [];
              this.pageData.total = 0;
              this.isLoadCompleted = true;
            }
          }
        })
        .catch(() => {
          this.isSearchLoading = false;
        });
    },

    toPath (trg) {
      let parmas = {
        id: trg.partialId,
        masterContractNum: this.contractNum,
        deliveryNum: trg.deliveryNum
      };
      this.$router.push({ name: 'BatchBase', query: parmas });
    },
    // 提交分配的按钮
    submit () {
      if (this.assignAllTotal > this.info.actualSettlementAmount) {
        this.$notify({
          title: '本次分配金额大于未分配金额，请进行调整',
          type: 'warning'
        });
        return;
      }
      let payList = [];
      let newList = [];
      this.tableData.forEach((item) => {
        if (item.assignAmount) {
          payList.push({
            // contractId: this.info.id,
            telegraphicTransferNum: item.telegraphicTransferNum,
            assignAmount: item.assignAmount,
            businessEntity: item.bussinessEntity
          });
          newList.push(item);
        }
      });
      newList.forEach((item) => {
        item.actualSettlementAmount = this.info.actualSettlementAmount;
        item.contractNum = this.info.contractNum;
      });
      if (!payList.length) {
        this.$notify({
          title: '请输入相应的分配款项',
          type: 'warning'
        });
        return;
      }
      // dialog 弹框 触发
      this.dialogVisible = true;
      this.tableDialog = newList;
      // 计算 是否显示预付款 提示信息
      this.sureNum = (this.info.prepaymentAmountStr + this.info.borrowPrice) - this.info.assignAll - this.allAmount();
    },
    // 合计
    getSummaries (param) {
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (column.label === '本次分配金额') {
          sums[index] = this.allAmount();
        }
      });
      return sums;
    },
    // 实际结算金额总计
    allAmount () {
      let cont = 0;
      this.tableDialog.forEach((item) => {
        cont = numAdd(cont, item.assignAmount);
      });
      cont = Number(cont).toFixed(2);
      return cont;
    },
    cancel () {
      this.dialogVisible = false;
    },
    submitAxios () {
      let payList = [];
      this.tableData.forEach((item) => {
        if (item.assignAmount) {
          payList.push({
            // contractId: this.info.id,
            telegraphicTransferNum: item.telegraphicTransferNum,
            assignAmount: item.assignAmount,
            businessEntity: item.bussinessEntity
          });
        }
      });

      let params = {
        id: this.info.id,
        contractNum: this.info.contractNum,
        contractType: this.info.contractType,
        assignInfoListVOList: payList
      };

      this.loading = true;
      dealtContractToAssignInfoListTransfer(params).then((res) => {
        this.dialogVisible = false;
        let json = res.data;
        if (json.status === '200') {
          this.$notify({
            title: '分配成功',
            type: 'success'
          });
          this.initData();
          this.loading = false;
        } else {
          this.loading = false;
        }
      }).catch(() => {
        this.loading = false;
      });
    },

    initData () {
      this.loading = true;
      this.pageData.pageIndex = 1;

      axios.all([
        getNotAssignedPartialByContractNum({ contractNum: this.contractNum }),
        getContractDetailAllInfoByConNum(this.contractNum),
        selectAssignInfoByContractNum({
          contractNum: this.contractNum,
          pageIndex: this.pageData.pageIndex,
          pageSize: this.pageData.pageSize
        })
      ])
        .then((res) => {
          this.loading = false;

          let deliveryData = res[0].data;
          let infoData = res[1].data;
          let tableData = res[2].data;

          if (deliveryData.status === '200') {
            this.deliveryNumList = deliveryData.data;
          }

          if (infoData.status === '200') {
            this.info = infoData.data;
          }

          if (tableData.status === '200') {
            if (tableData.data.list.length) {
              tableData.data.list.forEach((item) => (item.assignAmount = 0));
              this.tableData = tableData.data.list;
              this.pageData.total = tableData.data.total;
            } else {
              this.isLoadCompleted = true;
            }
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },

    assignBlur (row) {
      if (row.unusedAmount < row.assignAmount) {
        row.assignAmount = row.unusedAmount;
      }
      let num = 0;
      this.tableData.forEach((item) => {
        if (item.assignAmount > 0) {
          num = numAdd(num, item.assignAmount);
        }
      });
      if (num > this.info.actualSettlementAmount) {
        this.$notify.warning('本次分配金额不能大于未分配金额，请进行调整');
        row.assignAmount = 0;
      }
    },
    unallocatedAmount () {
      let num = 0;
      num = Subtr(this.info.actualSettlementAmount, this.info.assignAll);
      return num;
    },

    // 触底加载更多
    handleScroll: debounce(function () {
      if (this.pageData.total > this.tableData.length) {
        ++this.pageData.pageIndex;
      } else {
        this.isLoadCompleted = true;
        return false;
      }

      let params = {
        contractNum: this.contractNum,
        pageIndex: this.pageData.pageIndex,
        pageSize: this.pageData.pageSize,
        telegraphicTransferNum: this.searchForm.telegraphicTransferNum,
        minRemittanceAmount: this.searchForm.minRemittanceAmount,
        maxRemittanceAmount: this.searchForm.maxRemittanceAmount,
        ...this.formatRangeDate(this.searchForm.rangeDate)
      };
      selectAssignInfoByContractNum(params).then(res => {
        let { status, data } = res.data;
        if (status === '200') {
          if (data.list.length) {
            data.list.forEach((item) => (item.assignAmount = 0));
            this.tableData.push(...data.list);
            this.pageData.total = data.total;
          } else {
            this.isLoadCompleted = true;
          }
        }
      });
    })
  }

};
</script>
<style lang="scss" scoped>
@import "../../style/var";
.money {
  color: $--color-primary;
}
.amountSty {
  color: gray;
  font-size: 10px;
  display: inline-block;
  margin-left: 10px;
}

.append-wrap{
  display: flex;
  justify-content: center;
  align-items: center;
  height: 42px;

  .icon{
     font-size: 16px;
  }
}

.input-width{
  width: 120px;
}

.tange-date-width{
  width: 240px;
}

.footer-btn{
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}
</style>
